export default __webpack_public_path__ + "static/media/lazer.866aa9c5.png";